import styled from 'styled-components';
import { Row } from '@cuemath/comps';

export const HighlightedRow = styled(Row)`
  background-color: ${({ backgroundColor }) => backgroundColor || 'clear'};
`;

export const SectionHeaderRow = styled(Row)`
  alignitems: center;
  padding: 10px 0;
  background-color: ${({ backgroundColor }) => backgroundColor || 'clear'};
`;
